import React from 'react';
import styled from 'styled-components';

import { PageTitle, PageWrapper } from '../../components/pageComponents';
import { JoinUs } from '../../components';
import { FranchiseForm } from '../../containers';
import theme from '../../styles/theme';

const GrayLine = styled.div`
  background-color: ${theme.colors.grey2};
  height: 1px;
  width: 85%;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
`;

const JoinWrapper = styled.div`
  width: 85%;
  min-height: 280px;
`;

const PageSubtitle = styled.p`
  font-weight: bold;
  margin-bottom: 2em;
`;

const StyledPageTitle = styled(PageTitle)`
  margin: 0;
`;

const JoinFranchisee = () => {
  return (
    <PageWrapper>
      <StyledPageTitle>FAÇA PARTE</StyledPageTitle>
      <PageSubtitle>FRANQUEADO</PageSubtitle>
      <FranchiseForm />
      <GrayLine />
      <JoinWrapper>
        <JoinUs />
      </JoinWrapper>
    </PageWrapper>
  );
};

export default JoinFranchisee;
